<ng-container [ngSwitch]="sentimentValue">
    <span
        *ngSwitchCase="msSentimentTypeEnum.positive"
        class="sentiment positive"
        tooltip="{{ sentimentScore | confidencePercent }}"
        translate
        >Positive</span
    >
    <span
        *ngSwitchCase="msSentimentTypeEnum.neutral"
        class="sentiment text-light"
        tooltip="{{ sentimentScore | confidencePercent }}"
        translate
        >Neutral</span
    >
    <span
        *ngSwitchCase="msSentimentTypeEnum.negative"
        class="sentiment negative"
        tooltip="{{ sentimentScore | confidencePercent }}"
        translate
        >Negative</span
    >
</ng-container>
